import { render, staticRenderFns } from "./Actividad.vue?vue&type=template&id=50b3a506&scoped=true&lang=pug&"
import script from "./Actividad.vue?vue&type=script&lang=js&"
export * from "./Actividad.vue?vue&type=script&lang=js&"
import style0 from "./Actividad.vue?vue&type=style&index=0&id=50b3a506&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b3a506",
  null
  
)

export default component.exports